enum State {
    selected = 1,
    hidden = 2,     // locked
    deleted = 4
}

export { State };
